import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints.ts';

interface CreateAppointmentRequest {
  patientSFId?: string;
  scheduleDate?: string;
  endDate?: string;
  frequency?: string;
  type: 'In Clinic' | 'Physician Request' | 'Routine' | 'Heart Failure' | 'Combo' | 'ERI Tracking';
  modelNumber: string;
  serialNumber: string;
  deviceId?: string;
}

interface CancelAppointmentsRequest {
  patientSFId?: string;
  modelNumber: string;
  serialNumber: string;
  cancelEriOnly?: boolean;
  deviceId?: string;
}

export interface CreateAppointmentResponse {
  success: boolean;
  message: string;
  summary?: {
    nextDates: string[];
  };
}

interface CancelAppointmentsResponse {
  success: boolean;
  message: string;
  cancelledCount?: number;
}

export const schedulesApiSlice = createApi({
  reducerPath: 'schedulesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.Schedules],
  endpoints: (builder) => ({
    createAppointment: builder.mutation<CreateAppointmentResponse, CreateAppointmentRequest>({
      query: (appointmentData) => ({
        url: '/scheduled-transmission/create-appointment',
        method: 'POST',
        body: appointmentData
      }),
      invalidatesTags: [{ type: API_SLICE.Schedules, id: 'LIST' }]
    }),
    cancelAllScheduledAppointments: builder.mutation<
      CancelAppointmentsResponse,
      CancelAppointmentsRequest
    >({
      query: (cancelData) => ({
        url: '/scheduled-transmission/cancel-all-scheduled-appointments',
        method: 'POST',
        body: cancelData
      }),
      invalidatesTags: [{ type: API_SLICE.Schedules, id: 'LIST' }]
    })
  })
});

export const { useCreateAppointmentMutation, useCancelAllScheduledAppointmentsMutation } =
  schedulesApiSlice;
